import { PropType, computed, defineComponent, onUnmounted, ref, watch } from 'vue'
import { Store } from 'pinia'
import { ChargeMapContext } from '../../chargerMap/index.model'
import { ComponentActions, ComponentState } from '../../../nsh5/localStores/component'
import { RouteCDNModel } from '../../../models/detail.model'
import { IProps } from '@/components/NioMap/index.model'
import { MapViewMode } from '../../../contract/map'
import WishRender from './wishRender'
/**
 * 心愿站渲染功能模块
 */
export default defineComponent({
  name: 'wish-render-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
    cdnUrl: {
      type: RouteCDNModel,
      default: null,
    },
    settings: {
      // 地图设置
      type: Object as PropType<IProps>,
      default: {} as IProps,
    },
  },

  setup: (props) => {
    const mapContextRef = computed(() => props.mapContextRef)
    const mapInstance = computed(() => props.mapInstance)
    const componentStore = computed(() => props.componentStore)

    return () => (
      <>
        {componentStore.value.viewMode === MapViewMode.WishPower && (
          <>
            <WishRender
              mapContextRef={mapContextRef.value}
              mapInstance={mapInstance.value}
              componentStore={componentStore.value}
              cdnUrl={props.cdnUrl}
              settings={props.settings}
            ></WishRender>
          </>
        )}
      </>
    )
  },
})
